// extracted by mini-css-extract-plugin
export default {"image":"DX-z","loaded":"EX-z"};